/* eslint-disable */
export const INTERCOM_MODULE_NAME = 'intercom';
